var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fieldset",
    { attrs: { "data-testid": "target-duplicate-settings" } },
    [
      _c("legend", { staticClass: "col-lg-offset-1 col-lg-10" }, [
        _c("span", {
          directives: [
            {
              name: "t",
              rawName: "v-t",
              value: "TARGET_DUPLICATE_SETTINGS_TITLE",
              expression: "'TARGET_DUPLICATE_SETTINGS_TITLE'"
            }
          ]
        }),
        _vm._v(" "),
        _c(
          "a",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.right",
                value: _vm.$t("TARGET_DUPLICATE_SETTINGS_TITLE_TT"),
                expression: "$t('TARGET_DUPLICATE_SETTINGS_TITLE_TT')",
                modifiers: { right: true }
              }
            ],
            staticClass: "m-l-10 f-s-16"
          },
          [
            _vm._v("\n        "),
            _c("i", { staticClass: "fa fa-question-circle" })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("Field", {
            attrs: {
              label: _vm.$t("DUPLICATE_SETTINGS_OPTIONS"),
              "hide-label": false,
              "has-tooltip": true,
              "tooltip-text": _vm.$t("DUPLICATE_SETTINGS_OPTIONS_TT")
            },
            scopedSlots: _vm._u([
              {
                key: "element",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "col-sm-5 col-md-5" },
                      [
                        _c(
                          "ValidationProvider",
                          { attrs: { rules: "required", slim: "" } },
                          [
                            _c("SearchableDropdown", {
                              staticClass: "m-b-10",
                              attrs: {
                                value: _vm.dupeSettingOptionSelected,
                                name: "dupeRestrictOption",
                                config: _vm.dupeSettingsSelectConfig,
                                clearable: false,
                                disabled: _vm.disabled
                              },
                              on: { change: _vm.onDupeSettingChange }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _vm.showOverrideSettings
            ? _c(
                "div",
                [
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("RESTRICT_ON"),
                      "hide-label": false,
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("RESTRICT_ON_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("ValidationProvider", {
                                attrs: { rules: "required", slim: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({}) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-sm-4 col-md-3"
                                            },
                                            [
                                              _c("SearchableDropdown", {
                                                staticClass: "m-b-10",
                                                attrs: {
                                                  name: "conversionType",
                                                  config:
                                                    _vm.conversionTypeDropdownConfig,
                                                  clearable: false,
                                                  disabled: _vm.disabled
                                                },
                                                on: {
                                                  change:
                                                    _vm.onPayoutOnDropdownOnChange
                                                },
                                                model: {
                                                  value:
                                                    _vm.dupeSettingSelected
                                                      .previousCallState,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dupeSettingSelected,
                                                      "previousCallState",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dupeSettingSelected.previousCallState"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3795281033
                                )
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3778929422
                    )
                  }),
                  _vm._v(" "),
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("DUPLICATE_RESTRICTION_DURATION"),
                      "hide-label": false,
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t(
                        "DUPLICATE_RESTRICTION_DURATION_TT"
                      )
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "col-sm-6 col-md-6" },
                                [
                                  _c(
                                    "ValidationProvider",
                                    { attrs: { rules: "required", slim: "" } },
                                    [
                                      _c(
                                        "MultipleToggle",
                                        {
                                          attrs: {
                                            value:
                                              _vm.dupeRestrictOptionSelected,
                                            options:
                                              _vm.dupeRestrictToggleOptions,
                                            disabled: _vm.disabled
                                          },
                                          on: {
                                            onToggle:
                                              _vm.onDupeRestrictOptionsChange
                                          }
                                        },
                                        [
                                          _vm.dupeRestrictOptionSelected == 1
                                            ? _c(
                                                "div",
                                                { staticClass: "m-t-5" },
                                                [
                                                  _c(
                                                    "ValidationProvider",
                                                    {
                                                      attrs: {
                                                        rules: "required",
                                                        slim: ""
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.lazy",
                                                            value:
                                                              _vm.daysFromLastCall,
                                                            expression:
                                                              "daysFromLastCall",
                                                            modifiers: {
                                                              lazy: true
                                                            }
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control days-input",
                                                        attrs: {
                                                          type: "number",
                                                          min: "1",
                                                          disabled:
                                                            _vm.disabled,
                                                          oninput:
                                                            "validity.valid||(value='')"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.daysFromLastCall
                                                        },
                                                        on: {
                                                          change: [
                                                            function($event) {
                                                              _vm.daysFromLastCall =
                                                                $event.target.value
                                                            },
                                                            _vm.onDaysFromLastCallChange
                                                          ]
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("label", {}, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.daysFromLastCall > 1
                                                          ? "Days"
                                                          : "Day"
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2915137205
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showBuyerSettings
            ? _c(
                "div",
                [
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("RESTRICT_ON"),
                      "hide-label": false,
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("RESTRICT_ON_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("div", { staticClass: "col-sm-4 col-md-3" }, [
                                _c("label", { staticClass: "control-label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.buyerDuplicateSettings
                                        .previousCallState
                                    )
                                  )
                                ])
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1383357582
                    )
                  }),
                  _vm._v(" "),
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("DUPLICATE_RESTRICTION_DURATION"),
                      "hide-label": false,
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t(
                        "DUPLICATE_RESTRICTION_DURATION_TT"
                      )
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("div", { staticClass: "col-sm-6 col-md-6" }, [
                                _c("label", { staticClass: "control-label" }, [
                                  _vm._v(_vm._s(_vm.buyerRestrictionDuration))
                                ])
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1460615323
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }